import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const LOCATION_LEVEL_INDEX: Record<string, number> = { PROVINCE: 0, DISTRICT: 1, SECTOR: 2, CELL: 3, VILLAGE: 4 };

/**
 * Looks up one level (PROVINCE/DISTRICT/SECTOR/CELL/VILLAGE) of an entity's location chain.
 * `locationNames` is always ordered top-down (Province → Village); an entity registered above
 * village level simply has a shorter array. `fallback` is the entity's own single most-specific
 * location, used when no locationStack is available at all.
 */
export function getLocationLevelName(
  locationNames: string[] | null | undefined,
  level: 'PROVINCE' | 'DISTRICT' | 'SECTOR' | 'CELL' | 'VILLAGE',
  fallback?: { name: string; locationType: string } | null
): string | null {
  const index = LOCATION_LEVEL_INDEX[level];
  if (locationNames?.[index]) return locationNames[index];
  if (fallback?.locationType === level) return fallback.name;
  return null;
}
